import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/lang.js'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'sq',
  messages
})



// WEBPACK FOOTER //
// ./src/lang/i18n.js